module.exports = __webpack_public_path__ + "img/roll.78832fd0.svg";